module.exports = "/images/download-icon@2x.png?df024a730d45edfab82d4d457baa3bbc";